module.exports = __webpack_public_path__ + "static/media/blue-result.4fe18caa.png";